import styled from "styled-components";
import { device } from "../../breakpoints";

interface HeaderNavHamburgerHolderProp {
  open: boolean;
}

export const HeaderNav = styled.nav`
  position: fixed;
  height: min-content;
  z-index: 10;
  flex-flow: row;
  flex: none;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 28px;
  display: flex;
  top: 0;
  left: 50%;
  overflow: hidden;
  transform: translate(-50%);
  .content-holder {
    flex: none;
    max-width: 100%;
    width: 100%;
    position: relative;
  }
  .nav-holder {
    width: 100%;
    margin: 0 auto;
  }
  @media ${device.laptopL} {
    .header-nav-hamburger-holder {
      opacity: 1;
      display: flex;
    }
    .header-nav-l {
      opacity: 0;
      display: none;
    }
  }
`;

export const HeaderNavHolder = styled.nav<HeaderNavHamburgerHolderProp>`
  border: 1px solid var(--border-color-w1);
  border-radius: var(--size-1);
  max-width: 1140px;
  margin: 0 auto;
  backdrop-filter: blur(10px);
  background: rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  width: 100%;
  padding: 10px 16px;
  position: relative;
  overflow: hidden;
  .header-nav-holder-content-holder {
    display: flex;
    alig-items: center;
    flex: 1;
    min-width: 1px;
    width: 100%;
    padding: 0;
    display: flex;
    justify-content: space-between;
  }
  @media ${device.laptopL} {
    transition: all 0.7s;
    height: ${(p) => (p.open ? "328px" : "66px")};
  }
`;

export const HeaderNavLogo = styled.nav`
  display: flex;
  aling-items: center;
  width: min-content;
  height: min-content;
  padding: 0px;
  .header-logo-link-holder {
    display: flex;
    width: min-content;
    height: min-content;
    gap: var(--size-2);
    text-decoration: none;
  }
  .header-logo-logo {
    aspect-ratio: 1;
    height: 36px;
    > div {
    }
    .logo {
      width: 100%;
      height: 100%;
    }
  }
  .header-logo-name {
    > p {
      white-space: pre;
      font-size: var(--size-3);
      padding: 0;
      margin: 0;
      font-weight: 500;
      line-height: 1.2em;
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
    }
  }
`;

export const HeaderNavContent = styled.nav`
  display: flex;
  align-items: center;
  gap: var(--size-2);

  .links-container {
    white-space: pre;
    z-index: 1;
  }
  .links {
    text-transform: capitalize;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: var(--size-1);
    opacity: 0.8;
    transition: all 0.3s;

    &:hover {
      opacity: 0.6;
    }
  }
  .nav-text {
    padding: 0;
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 1em;
  }
`;

export const HeaderNavMobileHolder = styled.div<HeaderNavHamburgerHolderProp>`
  display: none;
  opacity: 0;
  flex-direction: column;
  gap: var(--size-2);
  .header-nav-m {
    flex-direction: column;
    display: ${(p) => (p.open ? "flex" : "none")};
    opacity: ${(p) => (p.open ? "1" : "0")};
  }
  @media ${device.laptopL} {
    display: flex;
    opacity: 1;
    padding: ${(p) => (p.open ? "12px 16px" : "0")};
  }
`;
export const HeaderNavButtonHolder = styled.div`
  > a {
    border-radius: 8px;
    padding: 6px 12px;
    display: flex;
    gap: 8px;
    text-decoration: none;
  }

  .circle {
    background: radial-gradient(
      50% 50% at 50% 50%,
      rgb(255, 255, 255) 52.88461446762085%,
      rgb(140, 87, 10) 100%
    );
    filter: blur(3px);
    -webkit-filter: blur(3px);
    border-radius: 100%;
    height: var(--size-4);
    position: absolute;
    top: -4px;
    left: 9px;
    right: 9px;
  }
  .top-blur {
    background: rgb(216, 135, 54);
    border-radius: 100%;
    filter: blur(10px);
    -webkit-filter: blur(10px);
    opacity: 0.5;
    height: 7px;
    z-index: 2;
    position: absolute;
    top: 1px;
    left: 0;
    right: 0;
  }
  .radial-gradient {
    background:linear-gradient(
  163deg,
  rgb(255, 223, 125) 28%,   /* The Base: Warm Gold */
  rgb(161, 115, 69) 54%,    /* The Shadow: Deep Bronze/Brown */
  rgba(21, 21, 21, 1) 68%,         /* The Void: Pure Black */
  rgb(97, 150, 242) 100%    /* The Pop: Cornflower Blue */
);

    border-radius: 8px;
    z-index: 1;
    position: absolute;
    inset: 0;
  }
  .inset {
    background: black;
    border-radius: 8px;
    z-index: 1;
    inset: 1px;
    position: absolute;
  }
  .button-holder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    width: min-content;
    padding: 0;
    overflow: hidden;
    height: 26px;
  }
  .button-label,
  .button-label-2 {
    white-space: nowrap;
    transition: all 0.4s;
    will-change: transform;
   

    z-index: 1;
    transform: none;
    display: flex;
    flex-direction: column;
  }
  .button-label-2 {
    opacity: 0;
  }

  .button-label-text {
    padding: 4px 0;
    margin: 0;
    text-transform: capitalize;
    text-decoration: none;
     color:white;
    
  }
  &:hover {
    .button-label-2,
    .button-label {
      transform: translateY(-32px);
    }
    .button-label-2 {
      opacity: 1;
    }
    .button-label {
      opacity: 0;
    }
  }
`;

export const HeaderNavHamburgerHolder = styled.div<HeaderNavHamburgerHolderProp>`
  opacity: 0;
  display: none;
  height: 44px;
  width: 44px;
  align-items: center;
  justify-content: space-evenly;
  border: 1px solid rgba(255, 255, 255, 0.1);
  flex-direction: column;
  cursor: pointer;
  border-radius: ${(p) => (p.open ? "100%" : "0")};

  transition: all 0.6s;

  .bar {
    background: rgb(153, 153, 153);
    border: 1px solid rgba(255, 255, 255, 0.1);
    position: ABSOLUTE;
    width: 100%;
    height: 0.1rem;
    transition: all 0.4s;
    flex: none;
  }
  .bar-2 {
    opacity: ${(p) => (p.open ? "0" : "1")};
    transform: ${(p) => (p.open ? "scaleX(0)" : "scaleX(1)")};
  }
  ,
  bar-1 {
  }
  .bar-3 {
    transform: ${(p) =>
      p.open
        ? "rotateZ(45deg) translateX(-3px) translateY(4px)"
        : "rotateZ(0)"};

    transform-origin: 100% 0;
  }
  .bar-1 {
    transform: ${(p) =>
      p.open
        ? "rotateZ(-45deg) translateX(-4px) translateY(-3px)"
        : "rotateZ(0)"};
    transform-origin: 95% 0;
  }

  .bar-holder {
    width: 80%;
    height: 0.1rem;
    display: flex;
  }
  &:hover {
    .bar {
      opacity: 0.8;
    }

    .bar-2 {
      transform: ${(p) => (p.open ? "scaleX(0)" : "scaleX(0.75)")};
    }
  }
`;
